import { Delete, Get, Post, Put } from "../consumir";
import { API_URL, API_URL_DEV, API_URL_LOCAL_DEV } from "../../env";
import axios from "axios";

const globalURL = API_URL;
export const getAllEvents = async () => {
  try {
    const response = await Get(`${globalURL}/event/all`);
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION GET ALL EVENTS", error);
  }
};
export const getAllEventsPaginedByClubId = async (values: {
  idClub: number;
  count: number;
}) => {
  try {
    const response = await Get(
      `${globalURL}/event/paginedbyclub/${values.idClub}/${values.count}`
    );
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION GET ALL EVENTS by idClub", error);
  }
};
export const getAllEventPagined = async (values: {
  page: number;
  idClub: number;
}) => {
  try {
    const response = await Get(
      `${globalURL}/event/all/${values.page}/${values.idClub}`
    );

    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION GET ALL EVENTS", error);
  }
};

export const getEventById = async (id: number) => {
  try {
    const response = await Get(`${globalURL}/event/find/${id}`);
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION GET EVENT", error);
  }
};

export const getEventsByClubId = async (values: { id: number }) => {
  try {
    const response = await Get(`${globalURL}/event/byclub/${values.id}`);
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION GET EVENTS BY CLUB", error);
  }
};

export const createEvent = async (values: any) => {
  try {
    const response = await Post(`${globalURL}/event/crear`, values);
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION CREATE EVENT", error);
  }
};

export const updateEventByiD = async (id: number, values) => {
  try {
    const response = await Put(`${globalURL}/event/update/${id}`, values);
    return response;
  } catch (error) {
    console.error(" ERROR NETWORK CONNECTION UPDATE EVENT", error);
  }
};

export const deleteEventById = async (id: number) => {
  try {
    const response = await Delete(`${globalURL}/event/${id}`);
    return response;
  } catch (error) {
    console.error(" ERROR NETWORK CONNECTION DELETE EVENT", error);
  }
};

export const deleteVideoById = async (id: string) => {
  try {
    const response = await Get(`${globalURL}/event/quit/${id}`);
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION DELETE VIDEO BY ID EVENT", error);
  }
};
